import { axiosBaseUrlMs } from 'instance/Axios';

import { GET_API_ENDPOINTS, POST_API_ENDPOINTS } from './Endpoints';

// const commonEndPoint = 'api/V2/';
// const handleApiRequest = async (method, endpoint, payload = null) => {
//     try {
//         const response =
//             method === 'GET'
//                 ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
//                 : await merchantCommonPost(endpoint, payload); // Pass body for POST

//         return response;
//     } catch (error) {
//         console.error('API Error:', error);
//         return null;
//     }
// };
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
const axiosAEPS = axiosBaseUrlMs('/api/gateway/aeps');
// const merchantCommonPost = async (apiEndPoint, payload) => {
//     const endPoint = commonEndPoint + apiEndPoint;
//     const token = localStorage.getItem('token');
//     let merchantEmpID;
//     const isEmployee = localStorage.getItem('isEmployee');
//     if (isEmployee === 'true') {
//         merchantEmpID = localStorage.getItem('empId');
//     }
//     const headers = {
//         Authorization: `Bearer ${token}`,
//         'Header-Merchant-Employee': merchantEmpID,
//         'Content-Type': 'application/json',
//         'X-Latitude': latitude,
//         'X-Longitude': longitude
//     };
//     try {
//         const response = await axiosInstanceLive.post(
//             endPoint,
//             payload,

//             {
//                 headers
//             }
//         );
//         return response;
//     } catch (error) {
//         console.log(error);
//         handleCatchError(error);
//         return error;
//     }
// };
const merchantCommonGetRequestForAEPS = async (apiEndPoint) => {
    try {
        const authToken = localStorage.getItem('AuthToken');

        const headers = { Authorization: `Bearer ${authToken}`, 'service-type': 'web', 'x-latitude': latitude, 'x-longitude': longitude };
        const response = await axiosAEPS.get(apiEndPoint, { headers });
        return response;
    } catch (error) {
        console.error('AEPS GET request error:', error);
        // handleCatchError(error);
        throw error;
    }
};

const merchantCommonPostRequestForAEPS = async (apiEndPoint, payload) => {
    try {
        const authToken = localStorage.getItem('AuthToken');

        const headers = { Authorization: `Bearer ${authToken}`, 'service-type': 'web', 'x-latitude': latitude, 'x-longitude': longitude };
        const response = await axiosAEPS.post(apiEndPoint, payload, { headers });
        return response;
    } catch (error) {
        console.error('AEPS POST request error:', error);
        // handleCatchError(error);
        throw error;
    }
};

export const TwoFactAuthApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.twoFactAuth, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
    return response;
};
export const balanceEnquiryApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.balanceEnquiry, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const miniStatementApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.miniStatement, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return error;
        });
    return response;
};
export const cashWithdrawalApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.cashWithdrawal, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const aadharDepositApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.aadharDeposit, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const aadharPayApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.aadharPay, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const paymentReceiptApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.paymentReceipt, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const aadharExistApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPostRequestForAEPS(POST_API_ENDPOINTS.aadharExist, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
export const checkPermissionApi = async () => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonGetRequestForAEPS(GET_API_ENDPOINTS.checkPermission)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            // console.log(error);
            return error;
        });
    return response;
};
